import { configureStore, UnknownAction } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import rootReducer, { RootState } from '../reducers';

const store = configureStore({
    reducer: rootReducer,
});

// AppDispatch needs to accept both actions and thunks
// configureStore includes thunk middleware by default, so dispatch supports thunks
export type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, UnknownAction>;

// Typed hooks for use throughout the app
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
